export const profileTranslations = {
    en: {
        back: "Back",
        title: "Create Account",
        subtitle: "Register as a Farmer",
        fullName: "Full Name",
        firstName: "First Name",
        firstNamePlaceholder: "Enter first name",
        lastName: "Last Name",
        lastNamePlaceholder: "Enter last name",
        gender: "Gender",
        genderPlaceholder: "Select Gender",
        age: "Age",
        agePlaceholder: "Enter age",
        email: "Email Address",
        role: "Selected Role",
        namePlaceholder: "Enter your name",
        mobile: "Mobile Number",
        mobilePlaceholder: "+91 Enter Phone",
        location: "Location (Optional)",
        locationPlaceholder: "e.g., Nashik, Maharashtra",
        state: "State",
        statePlaceholder: "Select State",
        district: "District",
        districtPlaceholder: "Select District",
        taluka: "Taluka",
        talukaPlaceholder: "Enter Taluka",
        village: "Village",
        villagePlaceholder: "Enter Village",
        prefLang: "Preferred Language",
        langEn: "English",
        langHi: "हिंदी",
        langMr: "मराठी",
        createAccount: "Create Account",
        searchPlaceholder: "Search...",
        noResults: "No results found",
        male: "Male",
        female: "Female",
        other: "Other",
        error_firstName: "First Name is required",
        error_lastName: "Last Name is required",
        error_gender: "Please select a gender",
        error_age: "Please enter a valid age",
        error_mobile: "Please enter a valid 10-digit mobile number",
        error_state: "Please select a state",
        error_district: "Please select a district",
        error_taluka: "Please enter your Taluka",
        error_village: "Please enter your Village",
        error_role: "Please select a role"
    },
    hi: {
        back: "वापस",
        title: "खाता बनाएं",
        subtitle: "किसान के रूप में पंजीकरण करें",
        fullName: "पूरा नाम",
        firstName: "पहला नाम",
        firstNamePlaceholder: "पहला नाम दर्ज करें",
        lastName: "अंतिम नाम",
        lastNamePlaceholder: "अंतिम नाम दर्ज करें",
        gender: "लिंग",
        genderPlaceholder: "लिंग चुनें",
        age: "आयु",
        agePlaceholder: "आयु दर्ज करें",
        email: "ईमेल पता",
        role: "चुनी गई भूमिका",
        namePlaceholder: "अपना नाम दर्ज करें",
        mobile: "मोबाइल नंबर",
        mobilePlaceholder: "+91 फोन नंबर दर्ज करें",
        location: "स्थान (वैकल्पिक)",
        locationPlaceholder: "उदा., नासिक, महाराष्ट्र",
        state: "राज्य",
        statePlaceholder: "राज्य चुनें",
        district: "ज़िला",
        districtPlaceholder: "ज़िला चुनें",
        taluka: "तहसील",
        talukaPlaceholder: "तहसील दर्ज करें",
        village: "गाँव",
        villagePlaceholder: "गाँव दर्ज करें",
        prefLang: "पसंदीदा भाषा",
        langEn: "English",
        langHi: "हिंदी",
        langMr: "मराठी",
        createAccount: "खाता बनाएं",
        searchPlaceholder: "खोजें...",
        noResults: "कोई परिणाम नहीं मिला",
        male: "पुरुष",
        female: "महिला",
        other: "अन्य",
        error_firstName: "पहला नाम आवश्यक है",
        error_lastName: "अंतिम नाम आवश्यक है",
        error_gender: "कृपया लिंग चुनें",
        error_age: "कृपया वैध आयु दर्ज करें",
        error_mobile: "कृपया एक वैध 10-अंकीय मोबाइल नंबर दर्ज करें",
        error_state: "कृपया एक राज्य चुनें",
        error_district: "कृपया एक जिला चुनें",
        error_taluka: "कृपया अपनी तहसील दर्ज करें",
        error_village: "कृपया अपना गाँव दर्ज करें",
        error_role: "कृपया एक भूमिका चुनें"
    },
    mr: {
        back: "मागे",
        title: "खाते तयार करा",
        subtitle: "शेतकरी म्हणून नोंदणी करा",
        fullName: "पूर्ण नाव",
        firstName: "पहिले नाव",
        firstNamePlaceholder: "पहिले नाव प्रविष्ट करा",
        lastName: "आडनाव",
        lastNamePlaceholder: "आडनाव प्रविष्ट करा",
        gender: "लिंग",
        genderPlaceholder: "लिंग निवडा",
        age: "वय",
        agePlaceholder: "वय प्रविष्ट करा",
        email: "ईमेल पत्ता",
        role: "निवडलेली भूमिका",
        namePlaceholder: "तुमचे नाव प्रविष्ट करा",
        mobile: "मोबाईल नंबर",
        mobilePlaceholder: "+91 फोन नंबर प्रविष्ट करा",
        location: "ठिकाण (पर्यायी)",
        locationPlaceholder: "उदा., नासिक, महाराष्ट्र",
        state: "राज्य",
        statePlaceholder: "राज्य निवडा",
        district: "जिल्हा",
        districtPlaceholder: "जिल्हा निवडा",
        taluka: "तालुका",
        talukaPlaceholder: "तालुका प्रविष्ट करा",
        village: "गाव",
        villagePlaceholder: "गाव प्रविष्ट करा",
        prefLang: "प्राधान्याची भाषा",
        langEn: "English",
        langHi: "हिंदी",
        langMr: "मराठी",
        createAccount: "खाते तयार करा",
        searchPlaceholder: "शोधा...",
        noResults: "कोणतेही परिणाम आढळले नाहीत",
        male: "पुरुष",
        female: "स्त्री",
        other: "इतर",
        error_firstName: "पहिले नाव आवश्यक आहे",
        error_lastName: "आडनाव आवश्यक आहे",
        error_gender: "कृपया लिंग निवडा",
        error_age: "कृपया वैध वय प्रविष्ट करा",
        error_mobile: "कृपया वैध 10-अंकी मोबाईल नंबर प्रविष्ट करा",
        error_state: "कृपया राज्य निवडा",
        error_district: "कृपया जिल्हा निवडा",
        error_taluka: "कृपया तुमचा तालुका प्रविष्ट करा",
        error_village: "कृपया तुमचे गाव प्रविष्ट करा",
        error_role: "कृपया भूमिका निवडा"
    }
};
